class ModalPpeStdSuccess {

    constructor(options) {
        this.options = Object.assign(ModalPpeStdSuccess.options, options);
    }

    getOptions() {
        return this.options;
    }
}

ModalPpeStdSuccess.options = {
    visibility: true,
    type: 'success',
    button: [{
        message: "Ver",
        callback: (scopeModal) => {
            scopeModal.closeModal();
            {
                ModalPpeStdSuccess.options.props.redirect()
            }
        }
    }],
    positionButtons: 'flex-end'
};

export default ModalPpeStdSuccess;